// extracted by mini-css-extract-plugin
module.exports = {"row":"PointOfInterestList_row__h_52H","loaderContainer":"PointOfInterestList_loaderContainer___vm13","paginationContainer":"PointOfInterestList_paginationContainer__1QMJ8"};